import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/main.scss'
import locale from 'element-ui/lib/locale/lang/mn'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  router,
  store,
  data: {
    fullscreenLoading: false,
    statusArray: [
      {
        id: 1,
        value: 100, // 100 user_created
        label: ' Хэрэглэгч бүртгэсэн'
      },
      {
        id: 2,
        value: 110, // 110 arrived_at_the_warehouse
        label: ' Эрээн дах агуулхаас гарсан'
      },
      {
        id: 3,
        value: 120, // 120 received_by_branch
        label: 'Монгол дах салбар хүлээн авсан'
      },
      {
        id: 4,
        value: 200, // 200 received_by_user
        label: ' Хэрэглэгч хүлээн авсан'
      },
      {
        id: 5,
        value: 130, // 130 delivery
        label: ' Хэрэглэгч хүргэлтээр авна'
      },
      {
        id: 6,
        value: 140, // 140 goToGet
        label: ' Хэрэглэгч салбараас очиж авна'
      },
      {
        id: 7,
        value: 150,
        label: ' Хэрэглэгч салбар дээр хадгалуулна'
      },
      {
        id: 8,
        value: 160,
        label: ' Хүргэлтийн ажилтанд хуваарилсан'
      },
      {
        id: 9,
        value: 170,
        label: ' Ачаа салбар дээр үлдсэн'
      },
      {
        id: 10,
        value: 180,
        label: ' Хүргэлт цуцлагдсан'
      }
    ],
    deliveryDetailDialog: false
  },
  render: h => h(App)
}).$mount('#app')
